import { getConfigFor } from './helpers/getConfigFor';

export const languageCode = getConfigFor.project<'nl' | 'en'>({
	op: 'nl',
	bgov: 'en',
});

export const timeZone = 'Europe/Amsterdam';

export const locale = getConfigFor.project<string>({
	op: 'nl',
	bgov: 'en-gb',
});

export const menuPath = getConfigFor.project<string>({
	op: '/menu/',
	bgov: '/overview/',
});

export const searchPath = getConfigFor.project<string>({
	op: '/zoeken/',
	bgov: '/search/',
});

export const searchParamQuery = getConfigFor.project<string>({
	op: 'zoekterm',
	bgov: 'query',
});

export const accessibilityCertificate = getConfigFor.project<string>({
	op: 'https://www.accessibility.nl/inspecties/inspectie/site-1118',
	bgov: 'http://www.accessibility.nl/inspecties/inspectie/site-1555',
});
